// [REFACTORING] Why a class?
export default class TextHelper {
  getFormattedDateString = (strDate) =>
    strDate.toString().replace(/\s/, 'T') + '-03:00'
}

export const getUrlWithoutProtocol = (url) => {
  return url.replace(/^https?:\/\//, '')
}
